<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAuth } from '@/app/auth/use-auth'

const { t } = useI18n()
const router = useRouter()
const auth = useAuth()
const failed = ref(false)

onMounted(async () => {
  const outcome = await auth.completeSignIn(window.location.href).catch(() => null)
  if (outcome?.kind === 'signed-in') {
    await router.replace(outcome.returnTo)
    return
  }
  if (outcome?.kind === 'declined') {
    await router.replace({ name: 'sign-in', query: { declined: '1' } })
    return
  }
  if (outcome?.kind === 'restart') {
    await router.replace({ name: 'sign-in' })
    return
  }
  failed.value = true
})
</script>

<template>
  <main class="mx-auto flex max-w-xl flex-col gap-4 p-8">
    <h1 class="text-[length:var(--text-step-6)] font-semibold text-[color:var(--color-text)]">
      {{ failed ? t('auth.callbackFailedTitle') : t('auth.callbackTitle') }}
    </h1>
    <p role="status" class="text-[color:var(--color-text-muted)]">
      {{ failed ? t('auth.callbackFailedBody') : t('app.loading') }}
    </p>
  </main>
</template>
